<!-- Header Structure -->
<template>
	<div>
		<v-navigation-drawer v-if="!horizontal" app fixed v-model="drawer" :mini-variant.sync="collapseSidebar"
			mini-variant-width="70" :width="250" class="Vuely-sidebar"
			:style="{ backgroundImage: 'url(' + selectedSidebarBgImage.url + ')' }"
			:class="{ 'background-none': !backgroundImage }" :right="rtlLayout">
			<!-- App Sidebar -->
			<app-sidebar></app-sidebar>
		</v-navigation-drawer>
		<v-toolbar class="Vuely-toolbar" app :color="activeHeaderFilter.class" fixed>
			<div class="d-custom-flex align-items-center navbar-left">
				<div v-if="!horizontal">
					<v-toolbar-side-icon icon large @click.stop="drawer = !drawer" class="v-step-0">
					</v-toolbar-side-icon>
				</div>
				<div class="site-logo-wrap d-custom-flex ml-0 align-items-center" v-else>
					<router-link to="/dashboard" class="grayish-blue site-logo-img">
						<span>Backoffice</span>
					</router-link>
				</div>
				<quick-audit class="hidden-md-and-up"></quick-audit>

				<v-select style="margin-left: 10px;" :items="seasons" box item-value="id" item-text="year"
					v-model="season" :label="$t('message.season')"></v-select>


				<!-- <v-text-field flat solo prepend-icon="search" :placeholder="$t('message.search')" class="search-bar"></v-text-field>
				<div class="mobile-search d-none">
					<v-btn flat icon  small class="mobile-search-btn" @click="toggleSearchForm">
						<v-icon class="font-md">search</v-icon>
					</v-btn>
				</div> -->
			</div>
			<div class="navbar-right">
				<!-- <header-label label="Sales" :value="sales" :is-cash="true" class="hidden-sm-and-down"></header-label>
				<header-label label="Arrangement fee" :value="arrangementFee" :is-cash="true" class="hidden-sm-and-down"></header-label>
				<header-label label="Sold tickets" :value="soldTickets" class="hidden-sm-and-down"></header-label> -->

				<v-tooltip bottom>
					<v-btn slot="activator" icon large @click="toggleFullScreen" class="full-screen ma-0">
						<v-icon color="grey">fullscreen</v-icon>
					</v-btn>
					<span>Toggle fullscreen</span>
				</v-tooltip>

				<!-- <v-btn class="ma-0" icon large @click.stop="chatSidebar = !chatSidebar">
					<v-icon color="grey">forum</v-icon>
				</v-btn> -->
				<!-- <notifications></notifications> -->
				<!-- <language-provider></language-provider> -->
				<user></user>

			</div>
		</v-toolbar>
		<!-- Chat Searchbar -->
		<!-- <v-navigation-drawer fixed v-model="chatSidebar" :right="!rtlLayout" temporary app class="chat-sidebar-wrap">
			<chat-sidebar></chat-sidebar>
		</v-navigation-drawer> -->
		<!-- <mobile-search-form></mobile-search-form> -->
	</div>
</template>

<script>
import Sidebar from '../Sidebar/Sidebar.vue'
// import ChatSidebar from '../ChatSidebar/ChatSidebar.vue'
import screenfull from 'screenfull'
// import LanguageProvider from './LanguageProvider'
import Notifications from './Notifications'
import User from './User'
// import Cart from './Cart'
import QuickAudit from './QuickAudit'
import HeaderLabel from './HeaderLabel'

// import MobileSearchForm from './MobileSearchForm'
import { getCurrentAppLayout } from 'Helpers/helpers'
import { mapGetters } from 'vuex'
import Enumerable from 'linq'

export default {
	props: {
		horizontal: {
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
			collapsed: false, // collapse sidebar
			drawer: null, // sidebar drawer default true
			chatSidebar: false, // chat component right sidebar
			sidebarImages: "", // sidebar background images
			enableDefaultSidebar: false
		};
	},
	computed: {
		...mapGetters([
			'rtlLayout',
			'backgroundImage',
			'backgroundImage',
			'selectedSidebarBgImage',
			'darkMode',
			'collapseSidebar',
			'activeHeaderFilter',
			'seasons',
			'user',
			'reportingData'
		]),
		season: {
			get() {
				return this.$store.state.settings.season
			},
			set(id) {
				this.$store.dispatch('setSeason', { seasonId: id, companyId: this.user.company.id },)
					.then(() => this.$store.dispatch('setUserSeason', id))
			}
		},
		// sales: function () {
		// 		if (this.reportingData.length > 0 && this.season) {
		// 			let enumerable = Enumerable
		// 				.from(this.reportingData)
		// 				.where(item => item['wo_status'] === 2)

		// 			return enumerable
		// 				.select(item => item['sales_total'])
		// 				.sum()
		// 		} else {
		// 			return 0
		// 		}
		// 	},
		// costs: function () {
		// 	if (this.reportingData.length > 0 && this.season) {
		// 		let enumerable = Enumerable
		// 			.from(this.reportingData)
		// 			.where(item => item['wo_status'] === 2)

		// 		return enumerable
		// 			.select(item => item['costs_total'])
		// 			.sum()
		// 	} else {
		// 		return 0
		// 	}
		// },
		// arrangementFee: function () {
		// 	if (this.reportingData.length > 0 && this.season) {
		// 		let enumerable = Enumerable
		// 			.from(this.reportingData)
		// 			.where(item => item['wo_status'] === 2)

		// 		return enumerable
		// 			.select(item => item['arrangement_fee'])
		// 			.sum()
		// 	} else {
		// 		return 0
		// 	}
		// },
		// soldTickets: function () {
		// 	if (this.reportingData.length > 0 && this.season) {
		// 		let enumerable = Enumerable
		// 			.from(this.reportingData)
		// 			.where(item => item['wo_status'] === 2)
		// 			.where(item => item['FK_ArticleType'] === 10 || item['FK_ArticleType'] === 1 || item['FK_ArticleType'] === 2)


		// 		return enumerable
		// 			.select(item => item['Menge'])
		// 			.sum()
		// 	} else {
		// 		return 0
		// 	}
		// }
	},
	methods: {
		// toggle full screen method
		toggleFullScreen() {
			if (screenfull.enabled) {
				screenfull.toggle();
			}
		},
		getMenuLink(link) {
			return '/' + getCurrentAppLayout(this.$router) + link;
		},
		toggleSearchForm() {
			this.$store.dispatch('toggleSearchForm');
		}
	},

	components: {
		appSidebar: Sidebar,
		// ChatSidebar,
		// LanguageProvider,
		Notifications,
		// Cart,
		QuickAudit,
		// MobileSearchForm,
		User,
		HeaderLabel
	},
	mounted() {
		this.$store.dispatch('getSeasons')
		this.$store.dispatch('getEventBaseGroups')
	},
};
</script>
